/** RFC 0359 experiment: a separate desktop instance can use the daemon directly. */
export function desktopDirectRequested(): boolean {
  if (!/Electron/.test(navigator.userAgent)) return false
  const offered = new URLSearchParams(window.location.search).get(
    'modDirectDaemon',
  )
  if (offered !== null)
    sessionStorage.setItem('mod.desktop.direct-repo', offered)
  return sessionStorage.getItem('mod.desktop.direct-repo') === '1'
}
